import { RadioButton } from 'primereact/radiobutton';
import styles from './RadioButton.module.css';

const AIEduRadioButton = (props) => {
    const { value, options, onChange, className, disabled } = props;

    return (
        <div className={className}>
            {options.map((option) => (
                <div key={option.value}>
                    <RadioButton
                        inputId={option.value}
                        name={option.name}
                        value={option.value}
                        checked={value === option.value}
                        onChange={onChange}
                        disabled={disabled}
                    />
                    <label
                        htmlFor={option.value}
                        className={styles.pp_radioButton_text}
                    >
                        {option.label}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default AIEduRadioButton;
